<template>
    <div class="header-bar" :height="headerHeight">
        <img src="@/assets/images/logo.png" alt="pic">
    </div>
</template>

<script type="text/javascript">
export default {
    name: 'header-bar',
    data() {
        return {
            headerHeight: ''
        }
    },
    mounted() {
        this.headerHeight = document.getElementsByClassName('header-bar')[0].offsetHeight;
    }
}
</script>

<style scope lang="sass">
    .header-bar
        // height: 60px;
        padding: 15px 0 10px 20px;
        background: #fff;
        overflow: hidden;
        border-bottom: 6px solid #d26932;
        margin-bottom: -1px;
        img
            width: 40%;
</style>


// WEBPACK FOOTER //
// src/components/Header.vue